/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Typography } from '@mui/material';

import { OverviewSectionProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const OverviewSection: React.FC<OverviewSectionProps> = (props) => {
  const { title, data } = props;

  const description = data?.[0]?.new_car_setting_description_sub;

  // ======================= HOOKS
  return (
    <Box>
      {title && (
        <Box sx={{ borderBottom: '2px solid', mb: 4 }}>
          <Typography fontWeight={700} fontSize={'1.25rem'} color="#1E242F">
            {title}
          </Typography>
        </Box>
      )}
      {description?.map((item: any, index: number) => {
        const desName =
          item.new_car_setting_description_name !== 'Summary'
            ? item.new_car_setting_description_name
            : null;
        return (
          <Box key={`${item.key}-${index}`}>
            {desName && <Typography fontWeight={700}>{desName}</Typography>}
            <div
              className="post-description"
              dangerouslySetInnerHTML={{
                __html: item.new_car_setting_description_sub_value ?? '',
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default OverviewSection;
